// QUANTI PIXEL VERI DISEGNA IL GIOCO
//
// Phaser 3, in `Scale.RESIZE`, fa `canvas.width = larghezza CSS` — si legge in
// `node_modules/phaser/src/scale/ScaleManager.js`, nel ramo RESIZE. Su uno
// schermo Retina, dove ogni pixel CSS ne copre due fisici, questo vuol dire
// disegnare la partita a META' risoluzione e lasciare che sia il browser a
// stirarla.
//
// La cosa che ne soffre di piu' sono i dischi dei power-up, e c'e' un motivo
// preciso: sono l'oggetto piu' piccolo e piu' dettagliato in scena. Larghi 45 px
// di mondo (raggio 15 dal server x3), disegnati come circuiti al neon di un
// pixel. A zoom 1, appena entrati in partita, quel disco riceveva 45 pixel veri
// e ne occupava 90 sullo schermo: un pixel disegnato ogni quattro accesi. Da qui
// lo sgranato — che NON e' un problema della texture, e infatti ridurla a
// 256x256 (5 settembre) l'aveva peggiorato: rimpicciolire la sorgente non
// aggiunge pixel a schermo, li toglie e basta.
//
// Phaser 3 non ha piu' un'opzione `resolution` (rimossa nella 3.16), quindi la
// dimensione del gioco DEVE essere in pixel fisici e la conversione la facciamo
// noi. Le due conseguenze da tenere a mente, ed e' per questo che il resto del
// codice passa da qui invece di leggere `this.scale.width`:
//
//   1. `scale.width/height` ora sono pixel FISICI. Tutto cio' che ragiona in
//      "quanto e' grande lo schermo per un essere umano" — la disposizione
//      della HUD, la soglia del layout compatto, la viewport dichiarata al
//      server — deve dividere per questa scala, o su Retina crederebbe di
//      stare su un monitor grande il doppio.
//   2. Le camere devono ingrandire della stessa quantita', o il mondo
//      apparirebbe grande la meta'.
//
// Il tetto a 2 non e' timidezza: il costo di riempimento cresce col QUADRATO
// della scala, e i telefoni dichiarano anche 3 o 4. A 3 si disegherebbero nove
// volte i pixel di prima con mille palline di cibo in scena. Da 2 in su, per
// giunta, l'occhio non distingue quasi piu' niente.
const MASSIMO = 2;

export const RENDER_SCALE = Math.min(Math.max(window.devicePixelRatio || 1, 1), MASSIMO);

// Le due misure dello schermo come le intende un essere umano (pixel CSS),
// partendo dalla dimensione del gioco (pixel fisici).
export function viewportCss(scaleManager) {
  return {
    w: scaleManager.width / RENDER_SCALE,
    h: scaleManager.height / RENDER_SCALE,
  };
}

// Aggancia una camera al sistema di coordinate CSS: chi disegna dentro questa
// camera continua a ragionare in pixel CSS (0,0 = angolo in alto a sinistra
// dello schermo), ma il risultato viene disegnato con RENDER_SCALE volte i
// pixel. E' quello che serve alla HUD, che e' scritta tutta in coordinate di
// schermo e non deve accorgersi di niente.
//
// Il rimescolamento dello scroll non e' un dettaglio: lo zoom di una camera
// Phaser ingrandisce attorno al CENTRO della camera, non attorno all'origine.
// Senza correzione, l'angolo in alto a sinistra della HUD finirebbe fuori
// schermo — e con lui leaderboard, minimappa e cash-out.
export function ancoraCameraAlloSchermo(camera) {
  const s = RENDER_SCALE;
  camera.setZoom(s);
  camera.setScroll(
    -camera.width * (s - 1) / (2 * s),
    -camera.height * (s - 1) / (2 * s)
  );
}
